import { BASE_API_URL } from '@/core/config';

export const ENDPOINTS = {
  APPS: {
    STUDY: `${BASE_API_URL}/study/`,
  },
  FCT: {
    ACTIVITY_LOG: `${BASE_API_URL}/activity-log/`,
    ADDENDUM: {
      BASE: `${BASE_API_URL}/addendum/`,
      REPORT: `${BASE_API_URL}/addendum/report/`,
      STUDY: `${BASE_API_URL}/addendum/study/`,
    },
    ADDENDUM_SESSION: {
      BASE: `${BASE_API_URL}/addendum-sessions/`,
      STUDY: `${BASE_API_URL}/addendum-sessions/study/`,
    },
    AI_MODEL_STATUS: {
      STUDY: `${BASE_API_URL}/ml/study/`,
    },
    APPS: {
      REPORT_ISSUE: `${BASE_API_URL}/apps/report-issue`,
      REPORT_SERVICE_DESK_ISSUE: `${BASE_API_URL}/apps/report-service-desk-issue`,
    },
    AUTH: {
      SESSION: `${BASE_API_URL}/auth/session`,
    },
    CARE_SERVICE_REPORT_ORGANS: {
      BASE: `${BASE_API_URL}/care-service-report-organs/`,
      STUDY: `${BASE_API_URL}/care-service-report-organs/study/`,
    },
    COMPARISON: {
      PRIOR_STUDIES: `${BASE_API_URL}/comparison/prior-studies`,
      PRIOR_STUDY: `${BASE_API_URL}/comparison/prior-study/`,
      REPORT_PDF: `${BASE_API_URL}/comparison/report-pdf/`,
    },
    CONDITION_TEMPLATE: `${BASE_API_URL}/condition-template/`,
    CWF: {
      DOCUMENT_TYPES: {
        BASE: `${BASE_API_URL}/cwf/document-types`,
      },
      DOCUMENTS: {
        ACTIVE: `${BASE_API_URL}/cwf/documents/active`,
        BASE: `${BASE_API_URL}/cwf/documents`,
        CARE_PLANS: `${BASE_API_URL}/cwf/documents/careplans`,
        STUDY: `${BASE_API_URL}/cwf/documents/study`,
      },
    },
    FINDING_FROM_CONDITION: {
      BASE: `${BASE_API_URL}/finding-from-condition/`,
    },
    FORM_STRUCTURE: `${BASE_API_URL}/form-structure/`,
    KEY_IMAGE: {
      BASE: `${BASE_API_URL}/key-image/`,
      RENDERED_SUMMARY: `${BASE_API_URL}/key-image/rendered-summary/`,
    },
    ME: {
      PREFERENCES: {
        BASE: `${BASE_API_URL}/preferences/`,
        DEFAULTS: `${BASE_API_URL}/preferences/defaults`,
        INIT: `${BASE_API_URL}/preferences/init`,
      },
    },
    OMNI_LLM: {
      GENERATE_ADDENDUM_SUMMARY: `${BASE_API_URL}/omni-llm/generate-addendum-summary`,
      GENERATE_FINAL_IMPRESSION: `${BASE_API_URL}/omni-llm/generate-final-impression`,
    },
    QUALITY_CONTROL: {
      STUDY: `${BASE_API_URL}/quality-control/study`,
    },
    QUESTIONNAIRE_RESPONSE: {
      STUDY: `${BASE_API_URL}/questionnaire-response/study/`,
    },
    RADIOLOGIST_NOTE: {
      REPORT: `${BASE_API_URL}/radiologist-note/report/`,
    },
    RENDERED_SUMMARY: {
      BASE: `${BASE_API_URL}/rendered-summary/`,
      REPORT: `${BASE_API_URL}/rendered-summary/report/`,
    },
    REPORT: {
      BASE: `${BASE_API_URL}/report/`,
      STUDY: `${BASE_API_URL}/report/study/`,
      URGENCY_CATEGORY: `${BASE_API_URL}/report/urgency-category/`,
    },
    REPORT_FINDING: {
      BASE: `${BASE_API_URL}/report-finding/`,
      REPORT: `${BASE_API_URL}/report-finding/report/`,
    },
    REPORT_ORGAN: {
      BASE: `${BASE_API_URL}/report-organ/`,
      BULK: `${BASE_API_URL}/report-organ/bulk`,
      FROM_UPDATED_FINDINGS: `${BASE_API_URL}/report-organ/from-updated-findings`,
      REPORT: `${BASE_API_URL}/report-organ/report/`,
    },
    REPORT_PDF: {
      BASE: `${BASE_API_URL}/report-pdf/`,
      STUDY: `${BASE_API_URL}/report-pdf/study/`,
    },
    SALESFORCE: {
      CARE_PLAN_ACTIVITIES: `${BASE_API_URL}/salesforce/care-plan-activities`,
      CARE_PLANS: `${BASE_API_URL}/salesforce/care-plans`,
    },
    STRUCTURED_OBSERVATION: {
      APPLY: `${BASE_API_URL}/structured-observation/apply`,
    },
  },
  HI: {
    DICOM: {
      DELETE_SERIES: `${BASE_API_URL}/dicom/deleteSeries`,
      SERIES_QUERY: `${BASE_API_URL}/dicom/series-query`,
      SERIES_RETRIEVE: `${BASE_API_URL}/dicom/series-retrieve`,
    },
    RADIOLOGIST: {
      STUDY: '/radiologist/study/',
    },
    STUDY: `${BASE_API_URL}/study/`,
  },
  PII: {
    PATIENT: `${BASE_API_URL}/userV2/`,
    USER: `${BASE_API_URL}/userV2/current`,
  },
} as const;
